
import { Component, Watch } from 'vue-property-decorator';
import { RouteNames } from '@/enums/routes/RouteNames';
import SettingsTopBar from '@/components/views/settings/SettingsTopBar.vue';
import { mixins } from 'vue-class-component';
import { UserRightsMixin } from '@/mixins/UserRights';
import NotAllowedComponent from '@/components/views/settings/NotAllowedComponent.vue';
import SyncLogTable from '@/components/views/CmsIndex/SyncLogTable.vue';
import { tableConfig } from '@/helpers/CmsIndexHelper';
import { debounce } from 'vue-debounce';
import { downloadExcelFile } from '@/helpers/PrintHelper';

@Component({
  name: 'ClientSyncLog',
  components: { SettingsTopBar, NotAllowedComponent, SyncLogTable },
})
export default class ClientSyncLog extends mixins<UserRightsMixin>(UserRightsMixin) {
  private backRoute: RouteNames = RouteNames.settings;
  private searchText = '';
  private filteredData: any = [];
  private debouncedSearch = debounce(() => this.applyFiltersAndSearch(), 500);

  private get config() {
    return tableConfig().find((c: any) => c.entityName === 'Client sync log');
  }

  private get userHasRights() {
    return this.isSuperAdmin;
  }

  private get tableData(): any[] {
    return this.config?.tableData() || [];
  }

  private async setInitialTableData() {
    await this.$nextTick();
    this.filteredData = this.tableData;
  }

  @Watch('searchText')
  private onSearchTextChange(val: string) {
    if (!val) {
      this.filteredData = this.tableData;
      return;
    }
    this.debouncedSearch();
  }

  private applyFiltersAndSearch() {
    const searchText = this.searchText.toLowerCase();
    this.filteredData = this.tableData.filter((row: any) =>
      Object.entries(row).some(
        ([key, value]) =>
          key !== 'key' && (typeof value === 'string' || typeof value === 'number') &&
          String(value).toLowerCase().includes(searchText),
      ),
    );
  }

  private downloadExcel() {
    try {
      downloadExcelFile(this.tableData as any[], 'Client sync log', ['key']);
    } catch {
      this.$notification.error({
        message: this.$t('Error') as string,
        description: this.$t('An error occurred while downloading the Excel file') as string,
      });
    }
  }
}
